import { render, staticRenderFns } from "./PrivacityPage.vue?vue&type=template&id=cad689d0&scoped=true"
import script from "./PrivacityPage.vue?vue&type=script&lang=js"
export * from "./PrivacityPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacityPage.vue?vue&type=style&index=0&id=cad689d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad689d0",
  null
  
)

export default component.exports